export function log(message, rewrite = false) {
  const textArea = document.getElementById("output");
  if (rewrite) textArea.value = message;
  else textArea.value = `${textArea.value} \n \n ${message}`;
}
